/* ------------------------------------------------------------------
  File: App.js
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-11
------------------------------------------------------------------ */

import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./app/routes";
import MainLayout from "./shared/components/layout/MainLayout";

function App() {
  return (
    <BrowserRouter>
      <MainLayout>
        <AppRoutes />
      </MainLayout>
    </BrowserRouter>
  );
}

export default App;